import { enumToStaticValue } from '@/utils'
import { RecordType } from '@/modules/record/type/RecordType'

export default enumToStaticValue(RecordType, 'record-type')
